import { ReactElement, useEffect } from 'react';
import { UISubNav, useUINav } from '@/ui';
import { useMyCompanyUser } from '@/companies/hooks';
import { usePagesTranslation } from '../hooks';
import { useAccountSettings } from './provider';
import { MemberPhoneSettingsSection } from '@/companies/components/member-phone-settings-section';

export function PhoneSettingsPage(): ReactElement | null {
    const { t } = usePagesTranslation();
    const { setParts } = useUINav();
    useEffect(() => {
        setParts([
            { text: t('shared.labels.account') },
            { text: t('shared.labels.phone') }
        ]);
    }, [setParts, t]);

    const {
        data: { user }
    } = useAccountSettings();
    const companyUser = useMyCompanyUser();

    if (!companyUser) {
        return null;
    }

    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                padding: 32,
                gap: 24
            }}
        >
            <UISubNav title={t('shared.labels.phone')} />
            {/* A user always has permission to edit their own phone. */}
            <MemberPhoneSettingsSection
                companyUser={companyUser}
                canEdit={true}
                isEmailVerified={user.emailVerified}
            />
        </div>
    );
}
